import { SkeletonLoader } from "../../SkeletonLoader";

const SKELETON_COUNT = 8;

function MarketingCardSkeleton() {
  return (
    <div className="overflow-hidden rounded-lg">
      <div className="aspect-[616/512]">
        <SkeletonLoader />
      </div>
      <div className="space-y-2 p-4">
        <SkeletonLoader
          variant="rectangular"
          height={16}
          className="rounded-[4px]"
        />
        <SkeletonLoader
          variant="rectangular"
          height={12}
          width="65%"
          className="rounded-[4px]"
        />
      </div>
    </div>
  );
}

export function BannerLibraryGridSkeleton() {
  return (
    <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {Array.from({ length: SKELETON_COUNT }).map((_, i) => (
        <MarketingCardSkeleton key={i} />
      ))}
    </div>
  );
}

export function BannerLibrarySkeleton() {
  return (
    <div className="flex flex-col gap-16">
      {/* Back button skeleton */}
      <SkeletonLoader
        variant="rectangular"
        width={140}
        height={20}
        className="rounded-[4px]"
      />

      <div className="flex flex-col gap-10">
        <SkeletonLoader
          variant="rectangular"
          width={260}
          height={48}
          className="rounded-[4px]"
        />

        <div className="flex items-center gap-4">
          <SkeletonLoader
            variant="rectangular"
            width={240}
            height={40}
            className="rounded-[8px]"
          />
          <SkeletonLoader
            variant="rectangular"
            width={88}
            height={40}
            className="rounded-[8px]"
          />
        </div>

        <BannerLibraryGridSkeleton />
      </div>
    </div>
  );
}
